import fetch from 'isomorphic-fetch';

// Polyfill Promises for IE and older browsers.
require('es6-promise').polyfill();


export default function lookUpBlockID(lookupID) {

const SEARCH_URI = "https://jccui.carto.com/api/v2/sql?q=SELECT DISTINCT blockid, ghg, ghgindex, ghgy, ghgrank, ghgmax, eui, euiindex, euiy, euirank, euimax, hydro, hydroindex, hydroy, hydrorank, hydromax, gas, gasindex, gasy, gasrank, gasmax, steam, steamindex, steamy, steamrank, steammax, cooling, coolingindex, coolingy, coolingrank, coolingmax, water, waterindex, watery, waterrank, watermax, transportation, transportationindex, transportationy, transportationrank, transportationmax, vintage, category FROM address_points_with_energy_and_emissions_20181105 WHERE blockid = " + lookupID;

  return fetch(`${SEARCH_URI}`)
    .then((resp) => resp.json())
    .then(({rows}) => {
      const retrieved = rows.map((i) => ({
        full_address: i.full_address,
				cartodb_id: i.cartodb_id,
				blockid: i.blockid,
				longitude: i.longitude,
				latitude: i.latitude,
				ghg: i.ghg,
				ghg_index: i.ghgindex,
				ghg_y: i.ghgy,
				ghg_rank: i.ghgrank,
				ghg_max: i.ghgmax,
				eui: i.eui,
				eui_index: i.euiindex,
				eui_y: i.euiy,
				eui_rank: i.euirank,
				eui_max: i.euimax,
				hydro: i.hydro,
				hydro_index: i.hydroindex,
				hydro_y: i.hydroy,
				hydro_rank: i.hydrorank,
				hydro_max: i.hydromax,
				gas: i.gas,
				gas_index: i.gasindex,
				gas_y: i.gasy,
				gas_rank: i.gasrank,
				gas_max: i.gasmax,
				steam: i.steam,
				steam_index: i.steamindex,
				steam_y: i.steamy,
				steam_rank: i.steamrank,
				steam_max: i.steammax,
				cooling: i.cooling,
				cooling_index: i.coolingindex,
				cooling_y: i.coolingy,
				cooling_rank: i.coolingrank,
				cooling_max: i.coolingmax,
				water: i.water,
				water_index: i.waterindex,
				water_y: i.watery,
				water_rank: i.waterrank,
				water_max: i.watermax,
				transportation: i.transportation,
				transportation_index: i.transportationindex,
				transportation_y: i.transportationy,
				transportation_rank: i.transportationrank,
				transportation_max: i.transportationmax,
				vintage: i.vintage,
				category: i.category,
      }));
      return {retrieved};
    });
}


// WEBPACK FOOTER //
// ./src/util/lookUpBlockID.js